import { deepcopy, trimFieldString } from "../util";

export function translateRemoveTooltip(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(remove_tooltip,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Remove tooltip in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "tooltip"
      },
      action: "remove"
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateAddTooltip(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_tooltip,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add tooltip in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "mark"
      },
      action: "add",
      option: {
        role: "tooltip",
        tooltip: {
          external: false,
          fixed: false,
        }
      }
    };
    if (layer.name) {
      rule.specifier.id = layer.name;
    } else {
      rule.specifier.index = text_map?.layer;
    }
    rules.push(rule);
  }
  return rules;
}

export function translateRepositionTooltip(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(fix_tooltip,L).
  // do(unfix_tooltip,L).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Remove tooltip in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "tooltip"
      },
      action: "reposition",
      option: {}
    };
    if (tech === "fix_tooltip") {
      rule.option = {
        external: true,
        fixed: true,
        position: "bottom"
      }
    } else if (tech === "unfix_tooltip") {
      rule.option = {
        external: false,
        fixed: false,
        position: null
      }
    }
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateAddTooltipField(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_tooltip_field,L,F).
  let layer = source.layer?.[mapping[args[0]]?.layer];
  let topptip_fields = deepcopy(layer.tooltip.fields);
  let field_name = trimFieldString(args[1])
  topptip_fields.push({ field: field_name });
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add a tooltip field in the layer ${layer.name || mapping[args[0]]?.layer}`,
      specifier: {
        role: "tooltip"
      },
      action: "modify",
      option: {
        fields: topptip_fields
      }
    };
    if (layer.name) {
      rule.specifier.id = layer.name;
    } else {
      rule.specifier.index = text_map?.layer;
    }
    rules.push(rule);
  }
  return rules;
}